import { render, staticRenderFns } from "./QuestionsType.vue?vue&type=template&id=080035e2&"
import script from "./QuestionsType.vue?vue&type=script&lang=js&"
export * from "./QuestionsType.vue?vue&type=script&lang=js&"
import style0 from "./QuestionsType.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports